module.exports = __webpack_public_path__ + "img/teste.3cc9d520.svg";